import { GetProductFormFieldsQuery, GetProductQuery } from "__generated__/view/products/graphql/product.queries.generated";
import { ChildProps } from "types/commons";

export type Product = ChildProps<GetProductQuery, "product">;
export type ProductFormFields = ChildProps<GetProductFormFieldsQuery, "product">;

export type ProductReviewDialogForm = {
	adnCode: number | null;
	publicationDate: string;
	unNumber: number | null;
	properShippingNameNL: string;
	properShippingNameEN: string;
	properShippingNameDE: string;
	properShippingNameFR: string;
	hazardCode: string;
	classification: string;
	classNumber: string;
	packingGroup: string;
	tankerType: string;
	cargoTankDesign: string;
	cargoTankType: string;
	cargoTankEquipment: string[];
	openingPressureRelieveValve: string;
	maxFillingDegreePercentage: string;
	samplingType: string;
	permissiblePumpChamberUnderDeck: boolean;
	temperatureClass: string;
	explosionGroup: string;
	explosionProtectionRequired: boolean;
	requiredEquipment: string[];
	numberOfBlueConesOrLights: number | null;
	extraRequirements: string;
	density: string;
	densityTemperature: number | null;
}

export enum ProductTypes {
	IDTF = "IDTF",
	NSTR = "NSTR",
	ADN = "ADN"
}
